import React, { useState, useEffect } from "react"
import axios from 'axios';
import {
    Col,
    Form,
    FormGroup,
    Input,
    Row,
    Button,
    FormFeedback,
    InputGroup
} from "reactstrap"

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import PropTypes from 'prop-types';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { nominationDetailsUrl, getCustomerNomineeDetailsUrl } from "../../helpers/fakebackend_helper";
import authHeader from "helpers/authHeader";

const Nomination = ({ RegistrationId }) => {

    const formBackground = {
        borderRadius: 8,
        flex: 1,
        ////backgroundColor: "rgb(247 242 242)",
        padding: "15px"
    }

    const tabHeading = {
        color: "#9a084f",
        fontWeight: "bold"
    }

    const label = {
        color: "black"
    }

    const formMandatory = {
        color: "red",
        fontWeight: "bold"
    }

    const formButton = {
        marginLeft: "20px",
        backgroundColor: "#9a084f",
        fontSize: "small",
        borderRadius: "0.50rem"
    }

    // $(".d-block").flatpickr({
    //     dateFormat: "d-M-Y",
    //     altFormat: "F j, Y",
    //     maxDate: "today",
    //     disableMobile: "true"
    // });

    const [branch, setBranch] = useState([]);
    const [showEasing, setshowEasing] = useState("swing");
    const [hideEasing, sethideEasing] = useState("linear");
    const [showMethod, setshowMethod] = useState("fadeIn");
    const [hideMethod, sethideMethod] = useState("fadeOut");
    const [showDuration, setshowDuration] = useState(300);
    const [hideDuration, sethideDuration] = useState(1000);
    const [timeOut, settimeOut] = useState(2000);
    const [extendedTimeOut, setextendedTimeOut] = useState(1000);
    const [isPreloader, setPreloader] = useState(false);

    function SuccessMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.success(message, "Information");
    }

    function ErrorMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.error(message, "Error");
    }

    const [nomineeData, setNomineeData] = useState([]);


    // Form validation
    const validation = useFormik({

        enableReinitialize: true,

        initialValues: {

            nameofnominee: nomineeData.nomineeName == null ? '' : nomineeData.nomineeName,
            address: nomineeData.nomineeAddress == null ? '' : nomineeData.nomineeAddress,
            relationshipwithdepositor: nomineeData.relationship == null ? '' : nomineeData.relationship,
            minordob: nomineeData.minorDOB == null ? '' : nomineeData.minorDOB,
            guardianname: nomineeData.guardianName == null ? '' : nomineeData.guardianName,
            guardianaddress: nomineeData.guardianAddress == null ? '' : nomineeData.guardianAddress,
            guardianrelation: nomineeData.guardianRelation == null ? '' : nomineeData.guardianRelation
        },
        validationSchema: Yup.object({
            nameofnominee: Yup.string().required("Name of nominee required").matches(/^[A-Za-z ]+$/, "Enter character only!"),
            address: Yup.string().required("Address required"),
            minordob: Yup.string().required("Date of Birth required"),
            guardianname: Yup.string().matches(/^[A-Za-z ]+$/, "Enter character only!"),
            guardianrelation: Yup.string().matches(/^[A-Za-z ]+$/, "Enter character only!"),
            relationshipwithdepositor: Yup.string().matches(/^[A-Za-z ]+$/, "Enter character only!")
        }),
        onSubmit: (values) => {
            //console.log("values", values);
        }
    });

    function CheckIsValid(controlValues) {
        var x = Object.keys(controlValues[0])
        var isCheckIfUndefined = x.map(p => {
            if (controlValues[0][p] === "" || controlValues[0][p] === undefined) {
                return true
            }
            else
                return false
        })

        var checkResponse = isCheckIfUndefined.includes(true)
        return checkResponse
    }

    const nomineeDetails = {
        RegistrationId: '',
        NameOfNominee: '',
        Address: '',
        RelationshipWithDepositor: '',
        PercentOfShare: '',
    }


    function chkNumeric(e) {
        let input = e.target.value;

        if (input == "") {
            validation.handleChange(e);
        }
        else if (typeof input !== "undefined") {
            var pattern = new RegExp(/^[0-9\b]+$/);
            if (pattern.test(input)) {
                validation.handleChange(e);
            }
        }
    }

    function dobValidation(value) {
        debugger;
        // const dobDate = value.target.value;
        const dobDate = value;
        if (dobDate != '') {
            var dob = new Date(dobDate);
            var today = new Date();
            var age = Math.floor((today - dob) / (365.25 * 24 * 60 * 60 * 1000));

            if (age < 18) {
                $("#txtguardianname").prop('disabled', false);
                $("#txtguardianaddress").prop('disabled', false);
                $("#txtguardianrelation").prop('disabled', false);
            }
            else {
                $("#txtguardianname").prop('disabled', true);
                $("#txtguardianaddress").prop('disabled', true);
                $("#txtguardianrelation").prop('disabled', true);

                $("#txtguardianname").prop('clear', true);
            }
        }
    }

    function dobValidationBind(dobDate) {
        debugger;
        validation.values.guardianname = "";
        validation.values.guardianaddress = "";
        validation.values.guardianrelation = "";

        if (dobDate != '') {
            var dob = new Date(dobDate);
            var today = new Date();
            var age = Math.floor((today - dob) / (365.25 * 24 * 60 * 60 * 1000));

            if (age < 18) {
                $("#txtguardianname").prop('disabled', false);
                $("#txtguardianaddress").prop('disabled', false);
                $("#txtguardianrelation").prop('disabled', false);
            }
            else {
                $("#txtguardianname").prop('disabled', true);
                $("#txtguardianaddress").prop('disabled', true);
                $("#txtguardianrelation").prop('disabled', true);
            }
        }
    }

    useEffect(() => {
        if (isPreloader === true) {
            document.getElementById("preloaderNominee").style.display = "block";
            document.getElementById("statusNominee").style.display = "block";
        } else {
            document.getElementById("preloaderNominee").style.display = "none";
            document.getElementById("statusNominee").style.display = "none";
        }
    }, [isPreloader]);

    useEffect(() => {
        GetCustomerNominationDetails();
    }, []);

    function GetCustomerNominationDetails() {
        const customerDetailModel = {
            RegistrationId: RegistrationId
        };

        axios.post(getCustomerNomineeDetailsUrl(), customerDetailModel, { headers: authHeader() })
            .then(response => {
                setNomineeData(response.data[0]);
                debugger;
                if (response.data.length > 0) {
                    dobValidationBind(response.data[0].minorDOB);
                }
            }, (error) => {
                console.log(error.response);
            })
    }

    function SaveNomineeDetails(RegistrationId) {
        debugger;
        var dob = new Date($('#txtminordob').val());
        var today = new Date();
        var age = Math.floor((today - dob) / (365.25 * 24 * 60 * 60 * 1000));

        if (age < 18) {
            if ($('#txtguardianname').val().trim() == "") {
                ErrorMessage("Please enter Guardian Name");
                $('#txtguardianname').focus();
                return;
            }
            else if ($('#txtguardianaddress').val().trim() == "") {
                ErrorMessage("Please enter Guardian Address");
                $('#txtguardianaddress').focus();
                return;
            }
            else if ($('#txtguardianrelation').val().trim() == "") {
                ErrorMessage("Please enter Guardian Relation");
                $('#txtguardianrelation').focus();
                return;
            }
        }

        nomineeDetails.RegistrationId = RegistrationId;
        nomineeDetails.NomineeName = $('#txtnameofnominee').val().trim();
        nomineeDetails.NomineeAddress = $('#txtaddress').val().trim();
        nomineeDetails.Relationship = $('#txtrelationshipwithdepositor').val().trim();
        nomineeDetails.MinorDOB = $('#txtminordob').val().trim();

        if (age < 18) {
            nomineeDetails.GuardianName = $('#txtguardianname').val().trim();
            nomineeDetails.GuardianAddress = $('#txtguardianaddress').val().trim();
            nomineeDetails.GuardianRelation = $('#txtguardianrelation').val().trim();
        }
        else {
            nomineeDetails.GuardianName = "";
            nomineeDetails.GuardianAddress = "";
            nomineeDetails.GuardianRelation = "";
        }

        setPreloader(true);
        axios.post(nominationDetailsUrl(), nomineeDetails, { headers: authHeader() })
            .then(res => {
                if (res.data.responseCode == "OK") {
                    SuccessMessage(res.data.responseMessage);
                    setPreloader(false);
                }
                else {
                    ErrorMessage(res.data.responseMessage);
                    setPreloader(false);
                }
            })
    }

    return (
        <React.Fragment>
            <div id="preloaderNominee">
                <div id="statusNominee">
                    <div className="spinner-chase">
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                    </div>
                </div>
            </div>

            <Row style={{ backgroundColor: "white" }}>
                <Col >
                    <div className="table-responsive">
                        <Form style={formBackground} className="needs-validation" onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}>
                            <Row>
                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Name of Nominee</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="nameofnominee"
                                            placeholder="Name of Nominee"
                                            type="text"
                                            className="form-control"
                                            id="txtnameofnominee"
                                            maxLength="200"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.nameofnominee || ""}
                                            style={{ textTransform: "capitalize" }}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.nameofnominee &&
                                                    (validation.touched &&
                                                        validation.touched.nameofnominee) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.nameofnominee &&
                                                (validation.touched &&
                                                    validation.touched.nameofnominee) ? (
                                                <FormFeedback type="invalid">{validation.errors.nameofnominee}</FormFeedback>
                                            ) : null}

                                    </FormGroup>
                                </Col>
                                <Col lg="4">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Address</label><span style={formMandatory}>*</span>
                                        <Input
                                            name="address"
                                            placeholder="Address"
                                            type="text"
                                            className="form-control"
                                            id="txtaddress"
                                            maxLength="500"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.address || ""}
                                            invalid={
                                                validation.errors &&
                                                    validation.errors.address &&
                                                    (validation.touched &&
                                                        validation.touched.address) ? true : false
                                            }
                                            autoComplete="off"
                                        />
                                        {
                                            validation.errors &&
                                                validation.errors.address &&
                                                (validation.touched &&
                                                    validation.touched.address) ? (
                                                <FormFeedback type="invalid">{validation.errors.address}</FormFeedback>
                                            ) : null}
                                    </FormGroup>
                                </Col>
                                <Col lg="3">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Relationship with the depositor if any</label>
                                        <Input
                                            name="relationshipwithdepositor"
                                            placeholder="Relationship with the depositor"
                                            type="text"
                                            className="form-control"
                                            id="txtrelationshipwithdepositor"
                                            maxLength="50"
                                            autoComplete="off"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.relationshipwithdepositor || ""}
                                            invalid={
                                                validation.touched.relationshipwithdepositor && validation.errors.relationshipwithdepositor ? true : false
                                            }
                                            autocomplete="off"
                                        />
                                        {validation.touched.relationshipwithdepositor && validation.errors.relationshipwithdepositor ? (
                                            <FormFeedback type="invalid">{validation.errors.relationshipwithdepositor}</FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                </Col>
                                <Col lg="2">
                                    <FormGroup className=" mb-3">
                                        <label style={label}>Date of Birth</label><span style={formMandatory}>*</span>
                                        {/* <div className="input-group">
                                            <Input
                                                id="txtminordob"
                                                name="minordob"
                                                placeholder="Date of Birth"
                                                type="text"
                                                className="form-control d-block flatpickr"
                                                onSelect={e => { validation.handleChange(e); dobValidation(e) }}
                                                value={validation.values.minordob || ""}
                                                invalid={
                                                    validation.touched.minordob && validation.errors.minordob ? true : false
                                                }
                                            />
                                            {validation.touched.minordob && validation.errors.minordob ? (
                                                <FormFeedback type="invalid">{validation.errors.minordob}</FormFeedback>
                                            ) : null}
                                        </div> */}
                                        <div className={validation.touched.minordob && validation.errors.minordob ? "flatpickr-error-style" : "flatpickr"}>
                                            <Flatpickr
                                                id="txtminordob"
                                                name="minordob"
                                                placeholder="Date of Birth"
                                                className={`form-control flatpickr ${
                                                    validation.touched.minordob && validation.errors.minordob
                                                        ? "is-invalid"
                                                        : ""
                                                    }`}
                                                onBlur={validation.handleBlur}
                                                onChange={([selectedDate], dateStr) => {
                                                    validation.setFieldValue("minordob", dateStr);
                                                    dobValidation(dateStr);
                                                }}
                                                options={{
                                                    dateFormat: "d-M-Y",
                                                    altFormat: "F j, Y",
                                                    maxDate: "today",
                                                    disableMobile: "true",
                                                }}
                                                value={validation.values.minordob || ""}
                                            />
                                        </div>
                                        <div>
                                            {validation.touched.minordob && validation.errors.minordob ? (
                                                <FormFeedback type="invalid">{validation.errors.minordob}</FormFeedback>
                                            ) : null}
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="4">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Guardian Name</label>
                                        <Input
                                            name="guardianname"
                                            placeholder="Guardian Name"
                                            type="text"
                                            className="form-control"
                                            id="txtguardianname"
                                            maxLength="100"
                                            autoComplete="off"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.guardianname || ""}
                                            style={{ textTransform: "capitalize" }}
                                            invalid={
                                                validation.touched.guardianname && validation.errors.guardianname ? true : false
                                            }
                                            autocomplete="off"
                                        />
                                        {validation.touched.guardianname && validation.errors.guardianname ? (
                                            <FormFeedback type="invalid">{validation.errors.guardianname}</FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                </Col>
                                <Col lg="6">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Guardian Address</label>
                                        <Input
                                            name="guardianaddress"
                                            placeholder="Guardian Address"
                                            type="text"
                                            className="form-control"
                                            id="txtguardianaddress"
                                            maxLength="200"
                                            autoComplete="off"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.guardianaddress || ""}
                                            autocomplete="off"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="2">
                                    <FormGroup className="mb-4">
                                        <label style={label}>Guardian Relation</label>
                                        <Input
                                            name="guardianrelation"
                                            placeholder="Guardian Relation"
                                            type="text"
                                            className="form-control"
                                            id="txtguardianrelation"
                                            maxLength="50"
                                            autoComplete="off"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.guardianrelation || ""}
                                            invalid={
                                                validation.touched.guardianrelation && validation.errors.guardianrelation ? true : false
                                            }
                                            autocomplete="off"
                                        />
                                        {validation.touched.guardianrelation && validation.errors.guardianrelation ? (
                                            <FormFeedback type="invalid">{validation.errors.guardianrelation}</FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="1">

                                </Col>
                                <Col lg="10">
                                </Col>
                                <Col lg="1">
                                    <Button id="firstN" style={formButton} type="submit"
                                        onClick={() => {
                                            let isEmpty = CheckIsValid([{
                                                nameofnominee: validation.errors.nameofnominee == undefined ? validation.values.nameofnominee : "",
                                                address: validation.values.address,
                                                minordob: validation.values.minordob,
                                                guardianname: validation.errors.guardianname == undefined ? validation.values.guardianname.length == 0 ? "guardianname" : validation.values.guardianname : "",
                                                guardianrelation: validation.errors.guardianrelation == undefined ? validation.values.guardianrelation.length == 0 ? "guardianrelation" : validation.values.guardianrelation : "",
                                                relationshipwithdepositor: validation.errors.relationshipwithdepositor == undefined ? validation.values.relationshipwithdepositor.length == 0 ? "relationshipwithdepositor" : validation.values.relationshipwithdepositor : ""
                                            }])
                                            if (!isEmpty)
                                                SaveNomineeDetails(RegistrationId);
                                        }} >
                                        Save
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Col>
            </Row >
        </React.Fragment >
    )
};

Nomination.propTypes = {
    RegistrationId: PropTypes.string
}

export default Nomination
